<template>
  <div class="merchant-management-container">
    <!-- 主内容区域 -->
    <div class="main-content">

      <!-- 操作按钮组 -->
      <div class="sub-button-group">
        <button class="sub-button orange-button" @click="showAddDialog">
          添加商户
        </button>
      </div>

      <!-- 内容区域 -->
      <div class="content-area">
        <!-- 搜索和操作栏 -->
        <div class="action-bar">
          <div class="search-bar">
            <el-input v-model="searchParams.phone" placeholder="搜索手机号" class="search-input" clearable>
              <template #prefix>
                <el-icon>
                  <Search />
                </el-icon>
              </template>
            </el-input>

            <el-input v-model="searchParams.nickname" placeholder="搜索昵称" class="search-input" clearable>
              <template #prefix>
                <el-icon>
                  <Search />
                </el-icon>
              </template>
            </el-input>

            <el-select v-model="searchParams.status" placeholder="状态筛选" class="status-select" clearable>
              <el-option label="启用" value="1" />
              <el-option label="禁用" value="0" />
            </el-select>

            <el-button type="primary" @click="handleSearch">
              <el-icon>
                <Search />
              </el-icon>
              搜索
            </el-button>

            <el-button @click="handleReset">
              <el-icon>
                <Refresh />
              </el-icon>
              重置
            </el-button>
          </div>
        </div>

        <!-- 数据表格 -->
        <el-table :data="tableData" v-loading="loading" class="data-table" :header-cell-style="{
          background: 'transparent',
          color: '#e0e6ff',
          borderBottom: '1px solid rgba(255, 112, 72, 0.3)'
        }">
          <el-table-column prop="id" label="ID" width="60" />
          <el-table-column prop="phone" label="手机号" width="110" />
          <el-table-column prop="nickname" label="昵称" width="110" />
          <el-table-column label="头像" width="80">
            <template #default="{ row }">
              <el-avatar :size="40" :src="row.avatar" v-if="row.avatar" />
              <el-avatar :size="40" v-else>{{ row.nickname?.charAt(0) }}</el-avatar>
            </template>
          </el-table-column>

          <!-- 在原有的 el-table-column 后面添加这些新字段 -->
          <el-table-column prop="dianshu" label="点数" width="50">
            <template #default="{ row }">
              <span :class="{ 'unlimited-text': row.dianshu == -1 }">
                {{ row.dianshu == -1 ? '无限' : row.dianshu }}
              </span>
            </template>
          </el-table-column>

          <el-table-column prop="deduct_points" label="扣点状态" width="80">
            <template #default="{ row }">
              <el-tag :type="row.deduct_points === 1 ? 'success' : 'warning'">
                {{ row.deduct_points === 1 ? '不扣点' : '扣点' }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="email" label="邮箱" width="160">
            <template #default="{ row }">
              <span v-if="row.email">{{ row.email }}</span>
              <span v-else class="empty-text">未设置</span>
            </template>
          </el-table-column>

          <el-table-column label="配额管理" width="150">
            <template #default="{ row }">
              <div class="quota-info">
                <div class="quota-item">
                  <span class="quota-label">第三方:</span>
                  <span :class="{ 'unlimited-text': row.third_party_media_count == -1 }">
                    {{ row.third_party_media_count == -1 ? '无限' : row.third_party_media_count }}
                  </span>
                </div>
                <div class="quota-item">
                  <span class="quota-label">B2B:</span>
                  <span :class="{ 'unlimited-text': row.b2b_count == -1 }">
                    {{ row.b2b_count == -1 ? '无限' : row.b2b_count }}
                  </span>
                </div>
                <div class="quota-item">
                  <span class="quota-label">自媒体:</span>
                  <span :class="{ 'unlimited-text': row.self_media_count == -1 }">
                    {{ row.self_media_count == -1 ? '无限' : row.self_media_count }}
                  </span>
                </div>
                <div class="quota-item">
                  <span class="quota-label">智能体:</span>
                  <span :class="{ 'unlimited-text': row.ai_agent_website_count == -1 }">
                    {{ row.ai_agent_website_count == -1 ? '无限' : row.ai_agent_website_count }}
                  </span>
                </div>
              </div>
            </template>
          </el-table-column>

          <!-- 新增字段显示 -->
          <el-table-column label="功能状态" width="120">
            <template #default="{ row }">
              <div class="function-status">
                <div class="status-item">
                  <span class="status-label">训练课:</span>
                  <el-tag size="small" :type="row.training_text_enabled ? 'success' : 'danger'">
                    {{ row.training_text_enabled ? '启用' : '禁用' }}
                  </el-tag>
                </div>
                <div class="status-item">
                  <span class="status-label">账号池:</span>
                  <el-tag size="small" :type="row.account_pool ? 'success' : 'danger'">
                    {{ row.account_pool ? '启用' : '禁用' }}
                  </el-tag>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="gender" label="性别" width="80">
            <template #default="{ row }">
              <span v-if="row.gender === 1">男</span>
              <span v-else-if="row.gender === 2">女</span>
              <span v-else>未知</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="80">
            <template #default="{ row }">
              <el-tag :type="row.status ? 'success' : 'danger'">
                {{ row.status ? '启用' : '禁用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="last_login_time" label="最后登录" />
          <el-table-column prop="create_time" label="创建时间" />
          <el-table-column label="操作" width="300" fixed="right">
            <template #default="{ row }">
              <el-button size="small" @click="handleEdit(row)" class="action-btn">
                编辑
              </el-button>
              <el-button size="small" @click="handleApiConfig(row)" class="action-btn" type="primary">
                接口配置
              </el-button>
              <el-button size="small" @click="handleStorageConfig(row)" class="action-btn" type="success">
                存储配置
              </el-button>
              <!-- 新增RPA接口配置按钮 -->
              <el-button size="small" @click="handleRpaConfig(row)" class="action-btn" type="info">
                RPA配置
              </el-button>
              <el-button size="small" @click="handleResetPassword(row)" class="action-btn" type="warning">
                重置密码
              </el-button>
              <el-button size="small" :type="row.status ? 'danger' : 'success'" @click="handleChangeStatus(row)"
                class="action-btn">
                {{ row.status ? '禁用' : '启用' }}
              </el-button>
              <el-button size="small" type="danger" @click="handleDelete(row)" class="action-btn">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination">
          <el-pagination v-model:current-page="pagination.page" v-model:page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50, 100]" :total="pagination.total" layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <!-- RPA接口配置对话框 -->
    <el-dialog v-model="showRpaConfigDialog" title="RPA接口配置" width="600px" :close-on-click-modal="false"
      class="merchant-dialog">
      <el-form :model="rpaConfigForm" ref="rpaConfigFormRef" label-width="140px">
        <el-form-item label="授权接口">
          <el-input v-model="rpaConfigForm.wpah_api_gzh_auth" placeholder="请输入授权接口地址" />
          <div class="field-tip">用于授权的RPA接口地址</div>
        </el-form-item>

        <el-form-item label="投放接口">
          <el-input v-model="rpaConfigForm.wpah_api_gzh_fb" placeholder="请输入内容投放接口地址" />
          <div class="field-tip">用于内容投放的RPA接口地址</div>
        </el-form-item>

        <el-form-item label="检测接口">
          <el-input v-model="rpaConfigForm.wpah_api_gzh_check_cookies" placeholder="请输入Cookie检测接口地址" />
          <div class="field-tip">用于检测Cookie状态的RPA接口地址</div>
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="showRpaConfigDialog = false">取消</el-button>
        <el-button type="primary" @click="handleRpaConfigSubmit" :loading="rpaConfigSubmitting">
          确定
        </el-button>
      </template>
    </el-dialog>

    <!-- 重置密码对话框 -->
    <el-dialog v-model="showResetPasswordDialog" title="重置密码" width="400px" :close-on-click-modal="false"
      class="merchant-dialog">
      <el-form :model="resetPasswordForm" :rules="resetPasswordRules" ref="resetPasswordFormRef" label-width="80px">
        <el-form-item label="新的密码" prop="password">
          <el-input v-model="resetPasswordForm.password" type="password" placeholder="请输入新密码" show-password />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="resetPasswordForm.confirmPassword" type="password" placeholder="请确认新密码" show-password />
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="showResetPasswordDialog = false">取消</el-button>
        <el-button type="primary" @click="handleResetPasswordSubmit" :loading="resettingPassword">
          确定
        </el-button>
      </template>
    </el-dialog>

    <!-- 添加/编辑商户对话框 -->
    <el-dialog v-model="showDialog" :title="dialogTitle" width="600px" :close-on-click-modal="false"
      class="merchant-dialog">
      <el-form :model="formData" :rules="formRules" ref="formRef" label-width="120px">
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="formData.phone" placeholder="请输入手机号" maxlength="11" />
        </el-form-item>

        <el-form-item label="昵称" prop="nickname">
          <el-input v-model="formData.nickname" placeholder="请输入昵称" />
        </el-form-item>

        <!-- 在原有的表单字段后面添加这些新字段 -->
        <el-form-item label="点数" prop="dianshu">
          <el-input-number v-model="formData.dianshu" :min="-1" :step="1" placeholder="请输入点数，-1表示无限"
            style="width: 100%" />
          <div class="field-tip">设置为-1表示无限点数</div>
        </el-form-item>

        <el-form-item label="扣点设置" prop="deduct_points">
          <el-radio-group v-model="formData.deduct_points">
            <el-radio :label="1">不扣点</el-radio>
            <el-radio :label="2">扣点</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="邮箱" prop="email">
          <el-input v-model="formData.email" placeholder="请输入邮箱地址" />
        </el-form-item>

        <el-divider content-position="left">配额设置</el-divider>

        <el-form-item label="第三方媒体" prop="third_party_media_count">
          <el-input-number v-model="formData.third_party_media_count" :min="-1" :step="1" placeholder="可发条数"
            style="width: 100%" />
          <div class="field-tip">设置为-1表示无限条数</div>
        </el-form-item>

        <el-form-item label="B2B平台" prop="b2b_count">
          <el-input-number v-model="formData.b2b_count" :min="-1" :step="1" placeholder="可发条数" style="width: 100%" />
          <div class="field-tip">设置为-1表示无限条数</div>
        </el-form-item>

        <el-form-item label="自媒体" prop="self_media_count">
          <el-input-number v-model="formData.self_media_count" :min="-1" :step="1" placeholder="可发条数"
            style="width: 100%" />
          <div class="field-tip">设置为-1表示无限条数</div>
        </el-form-item>

        <el-form-item label="智能体官网" prop="ai_agent_website_count">
          <el-input-number v-model="formData.ai_agent_website_count" :min="-1" :step="1" placeholder="可发条数"
            style="width: 100%" />
          <div class="field-tip">设置为-1表示无限条数</div>
        </el-form-item>

        <el-divider content-position="left">新增配置</el-divider>

        <el-form-item label="授权数" prop="sq_num">
          <el-input-number v-model="formData.sq_num" :min="-1" :step="1" placeholder="授权数" style="width: 100%" />
        </el-form-item>

        <el-form-item label="官网授权数" prop="official_auth_count">
          <el-input-number v-model="formData.official_auth_count" :min="-1" :step="1" placeholder="官网授权数"
            style="width: 100%" />
        </el-form-item>

        <el-form-item label="账号池" prop="account_pool">
          <el-radio-group v-model="formData.account_pool">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="训练课文" prop="training_text_enabled">
          <el-radio-group v-model="formData.training_text_enabled">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="授权账号" prop="auth_account_enabled">
          <el-radio-group v-model="formData.auth_account_enabled">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="接口配置" prop="api_config_enabled">
          <el-radio-group v-model="formData.api_config_enabled">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="存储配置" prop="storage_config_enabled">
          <el-radio-group v-model="formData.storage_config_enabled">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="智能体配置" prop="ai_agent_enabled">
          <el-radio-group v-model="formData.ai_agent_enabled">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="密码" prop="password" v-if="isAdd">
          <el-input v-model="formData.password" type="password" placeholder="请输入密码" show-password />
        </el-form-item>

        <el-form-item label="性别" prop="gender">
          <el-radio-group v-model="formData.gender">
            <el-radio :label="0">未知</el-radio>
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="状态" prop="status">
          <el-switch v-model="formData.status" :active-value="1" :inactive-value="0" />
        </el-form-item>

        <el-form-item label="过期时间" prop="out_date">
          <el-date-picker v-model="formData.out_date" type="datetime" placeholder="选择过期时间"
            value-format="YYYY-MM-DD HH:mm:ss" />
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="showDialog = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitting">
          确定
        </el-button>
      </template>
    </el-dialog>

    <!-- AI接口配置对话框 -->
    <el-dialog v-model="showApiConfigDialog" title="AI接口配置" width="700px" :close-on-click-modal="false"
      class="merchant-dialog">
      <el-form :model="apiConfigForm" ref="apiConfigFormRef" label-width="140px">
        <el-tabs v-model="apiConfigActiveTab">
          <!-- Coze配置 -->
          <el-tab-pane label="Coze配置" name="coze">
            <el-form-item label="启用状态">
              <el-switch v-model="apiConfigForm.coze_enabled" :active-value="1" :inactive-value="0" />
            </el-form-item>

            <el-form-item label="Access Token">
              <el-input v-model="apiConfigForm.coze_access_token" placeholder="请输入Coze Access Token" type="password"
                show-password />
            </el-form-item>

            <el-form-item label="智能体名称">
              <el-input v-model="apiConfigForm.coze_name" placeholder="请输入智能体名称" />
            </el-form-item>

            <el-form-item label="智能体ID">
              <el-input v-model="apiConfigForm.coze_botid" placeholder="请输入智能体Bot ID" />
            </el-form-item>

            <el-form-item label="对话模式">
              <el-radio-group v-model="apiConfigForm.coze_chat_mode">
                <el-radio label="stream">流式</el-radio>
                <el-radio label="batch">批量</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="响应超时(秒)">
              <el-input-number v-model="apiConfigForm.coze_timeout" :min="10" :max="300" :step="5" />
            </el-form-item>
          </el-tab-pane>

          <!-- OpenAI配置 -->
          <el-tab-pane label="OpenAI配置" name="openai">
            <el-form-item label="启用状态">
              <el-switch v-model="apiConfigForm.openai_enabled" :active-value="1" :inactive-value="0" />
            </el-form-item>

            <el-form-item label="API地址">
              <el-input v-model="apiConfigForm.openai_url" placeholder="请输入OpenAI API地址" />
            </el-form-item>

            <el-form-item label="API密钥">
              <el-input v-model="apiConfigForm.openai_key" placeholder="请输入OpenAI API密钥" type="password"
                show-password />
            </el-form-item>

            <el-form-item label="模型">
              <el-input v-model="apiConfigForm.openai_model" placeholder="请输入模型名称，如：gpt-3.5-turbo" />
            </el-form-item>

            <el-form-item label="最大令牌数">
              <el-input-number v-model="apiConfigForm.openai_max_tokens" :min="100" :max="4000" :step="100" />
            </el-form-item>

            <el-form-item label="温度参数">
              <el-slider v-model="apiConfigForm.openai_temperature" :min="0" :max="2" :step="0.1" show-stops />
              <span class="slider-value">{{ apiConfigForm.openai_temperature }}</span>
            </el-form-item>
          </el-tab-pane>
        </el-tabs>
      </el-form>

      <template #footer>
        <el-button @click="showApiConfigDialog = false">取消</el-button>
        <el-button type="primary" @click="handleApiConfigSubmit" :loading="apiConfigSubmitting">
          确定
        </el-button>
      </template>
    </el-dialog>

    <!-- 存储配置对话框 -->
    <el-dialog v-model="showStorageConfigDialog" title="存储配置" width="700px" :close-on-click-modal="false"
      class="merchant-dialog">
      <el-form :model="storageConfigForm" ref="storageConfigFormRef" label-width="140px">
        <el-form-item label="云服务商">
          <el-radio-group v-model="storageConfigForm.cloud_provider">
            <el-radio label="local">本地存储</el-radio>
            <el-radio label="aliyun">阿里云</el-radio>
            <el-radio label="tencent">腾讯云</el-radio>
            <el-radio label="qiniu">七牛云</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 本地存储提示 -->
        <div v-if="storageConfigForm.cloud_provider === 'local'" class="local-storage-tip">
          <el-alert title="本地存储配置" type="info" :closable="false" show-icon>
            <p>选择本地存储后，文件将存储在服务器本地目录，无需额外配置。</p>
          </el-alert>
        </div>

        <el-tabs v-model="storageConfigActiveTab" v-else>
          <!-- 阿里云配置 -->
          <el-tab-pane label="阿里云" name="aliyun">
            <el-form-item label="启用状态">
              <el-switch v-model="storageConfigForm.aliyun_enabled" :active-value="1" :inactive-value="0" />
            </el-form-item>

            <el-form-item label="AccessKey ID">
              <el-input v-model="storageConfigForm.aliyun_keyid" placeholder="请输入阿里云AccessKey ID" />
            </el-form-item>

            <el-form-item label="AccessKey Secret">
              <el-input v-model="storageConfigForm.aliyun_secret" placeholder="请输入阿里云AccessKey Secret" type="password"
                show-password />
            </el-form-item>

            <el-form-item label="Endpoint">
              <el-input v-model="storageConfigForm.endpoint" placeholder="请输入OSS Endpoint" />
            </el-form-item>

            <el-form-item label="Bucket名称">
              <el-input v-model="storageConfigForm.aliyun_bucket" placeholder="请输入Bucket名称" />
            </el-form-item>

            <el-form-item label="访问域名">
              <el-input v-model="storageConfigForm.aliyun_domain" placeholder="请输入自定义访问域名" />
            </el-form-item>
          </el-tab-pane>

          <!-- 腾讯云配置 -->
          <el-tab-pane label="腾讯云" name="tencent">
            <el-form-item label="启用状态">
              <el-switch v-model="storageConfigForm.tencent_enabled" :active-value="1" :inactive-value="0" />
            </el-form-item>

            <el-form-item label="SecretId">
              <el-input v-model="storageConfigForm.tencent_secret_id" placeholder="请输入腾讯云SecretId" />
            </el-form-item>

            <el-form-item label="SecretKey">
              <el-input v-model="storageConfigForm.tencent_secret_key" placeholder="请输入腾讯云SecretKey" type="password"
                show-password />
            </el-form-item>

            <el-form-item label="Bucket名称">
              <el-input v-model="storageConfigForm.tencent_bucket" placeholder="请输入Bucket名称" />
            </el-form-item>

            <el-form-item label="地域">
              <el-input v-model="storageConfigForm.tencent_region" placeholder="请输入地域，如：ap-beijing" />
            </el-form-item>

            <el-form-item label="访问域名">
              <el-input v-model="storageConfigForm.tencent_domain" placeholder="请输入自定义访问域名" />
            </el-form-item>
          </el-tab-pane>

          <!-- 七牛云配置 -->
          <el-tab-pane label="七牛云" name="qiniu">
            <el-form-item label="启用状态">
              <el-switch v-model="storageConfigForm.qiniu_enabled" :active-value="1" :inactive-value="0" />
            </el-form-item>

            <el-form-item label="AccessKey">
              <el-input v-model="storageConfigForm.qiniu_access_key" placeholder="请输入七牛云AccessKey" />
            </el-form-item>

            <el-form-item label="SecretKey">
              <el-input v-model="storageConfigForm.qiniu_secret_key" placeholder="请输入七牛云SecretKey" type="password"
                show-password />
            </el-form-item>

            <el-form-item label="Bucket名称">
              <el-input v-model="storageConfigForm.qiniu_bucket" placeholder="请输入Bucket名称" />
            </el-form-item>

            <el-form-item label="地域">
              <el-input v-model="storageConfigForm.qiniu_region" placeholder="请输入地域" />
            </el-form-item>

            <el-form-item label="访问域名">
              <el-input v-model="storageConfigForm.qiniu_domain" placeholder="请输入自定义访问域名" />
            </el-form-item>
          </el-tab-pane>
        </el-tabs>
      </el-form>

      <template #footer>
        <el-button @click="showStorageConfigDialog = false">取消</el-button>
        <el-button type="primary" @click="handleStorageConfigSubmit" :loading="storageConfigSubmitting">
          确定
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import { Search, Refresh } from '@element-plus/icons-vue'
import axios from 'axios'
import config from '@/config'
import Cookies from 'js-cookie'

export default {
  name: 'MerchantManagement',
  components: {
    Search,
    Refresh
  },
  data() {
    return {
      loading: false,
      showDialog: false,
      submitting: false,
      formRef: null,
      // RPA接口配置相关
      showRpaConfigDialog: false,
      rpaConfigSubmitting: false,
      rpaConfigFormRef: null,
      rpaConfigForm: {
        id: null,
        wpah_api_gzh_auth: '',
        wpah_api_gzh_fb: '',
        wpah_api_gzh_check_cookies: ''
      },
      // 重置密码相关
      showResetPasswordDialog: false,
      resettingPassword: false,
      resetPasswordForm: {
        id: null,
        password: '',
        confirmPassword: ''
      },
      resetPasswordFormRef: null,

      // AI接口配置相关
      showApiConfigDialog: false,
      apiConfigSubmitting: false,
      apiConfigFormRef: null,
      apiConfigActiveTab: 'coze',
      apiConfigForm: {
        id: null,
        // Coze配置
        coze_access_token: '',
        coze_name: '',
        coze_botid: '',
        coze_chat_mode: 'stream',
        coze_timeout: 30,
        coze_enabled: 1,
        // OpenAI配置
        openai_url: '',
        openai_key: '',
        openai_model: '',
        openai_max_tokens: 2000,
        openai_temperature: 0.7,
        openai_enabled: 1
      },

      // 存储配置相关
      showStorageConfigDialog: false,
      storageConfigSubmitting: false,
      storageConfigFormRef: null,
      storageConfigActiveTab: 'aliyun',
      storageConfigForm: {
        id: null,
        // 阿里云配置
        aliyun_keyid: '',
        aliyun_secret: '',
        endpoint: '',
        aliyun_bucket: '',
        aliyun_domain: '',
        aliyun_enabled: 1,
        // 腾讯云配置
        tencent_secret_id: '',
        tencent_secret_key: '',
        tencent_bucket: '',
        tencent_region: '',
        tencent_domain: '',
        tencent_enabled: 1,
        // 七牛云配置
        qiniu_access_key: '',
        qiniu_secret_key: '',
        qiniu_bucket: '',
        qiniu_region: '',
        qiniu_domain: '',
        qiniu_enabled: 1,
        // 云服务商选择
        cloud_provider: 'local'
      },

      // 搜索参数
      searchParams: {
        phone: '',
        nickname: '',
        status: ''
      },

      // 分页数据
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },

      // 表格数据
      tableData: [],

      // 表单数据
      formData: {
        phone: '',
        nickname: '',
        password: '',
        gender: 0,
        status: 1,
        out_date: '',
        // 原有字段
        dianshu: 0,
        deduct_points: 1,
        email: '',
        third_party_media_count: 1,
        b2b_count: 1,
        self_media_count: 1,
        ai_agent_website_count: 1,
        // 新增字段
        sq_num: null,
        official_auth_count: null,
        account_pool: null,
        training_text_enabled: null,
        auth_account_enabled: null,
        api_config_enabled: null,
        storage_config_enabled: null,
        ai_agent_enabled: null,
        wpah_api_gzh_auth: '',
        wpah_api_gzh_fb: '',
        wpah_api_gzh_check_cookies: ''
      },

      // 表单验证规则
      formRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        nickname: [
          { required: true, message: '请输入昵称', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ],
        dianshu: [
          { required: true, message: '请输入点数', trigger: 'blur' }
        ],
        deduct_points: [
          { required: true, message: '请选择扣点设置', trigger: 'change' }
        ]
      },

      // 重置密码验证规则
      resetPasswordRules: {
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.resetPasswordForm.password) {
                callback(new Error('两次输入的密码不一致'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    userInfo() {
      return JSON.parse(Cookies.get('user_info') || '{}')
    },
    isAdd() {
      return !this.formData.id
    },
    dialogTitle() {
      return this.isAdd ? '添加商户' : '编辑商户'
    }
  },
  mounted() {
    this.loadMerchantData();
  },
  methods: {
    // 加载商户数据
    async loadMerchantData() {
      this.loading = true
      try {
        const response = await axios.post(`${config.BASE_URL}/site/api/user_management.php`, {
          action: 'list',
          store_id: this.userInfo.id,
          page: this.pagination.page,
          page_size: this.pagination.pageSize,
          ...this.searchParams
        })

        if (response.data.data) {
          // 确保数字字段正确转换
          this.tableData = response.data.data.map(item => ({
            ...item,
            dianshu: Number(item.dianshu),
            deduct_points: Number(item.deduct_points),
            third_party_media_count: Number(item.third_party_media_count),
            b2b_count: Number(item.b2b_count),
            self_media_count: Number(item.self_media_count),
            ai_agent_website_count: Number(item.ai_agent_website_count),
            // 新增字段转换
            sq_num: Number(item.sq_num) || null,
            official_auth_count: Number(item.official_auth_count) || null,
            account_pool: Number(item.account_pool) || 0,
            training_text_enabled: Number(item.training_text_enabled) || 0,
            auth_account_enabled: Number(item.auth_account_enabled) || 0,
            api_config_enabled: Number(item.api_config_enabled) || 0,
            storage_config_enabled: Number(item.storage_config_enabled) || 0,
            ai_agent_enabled: Number(item.ai_agent_enabled) || 0
          }))
          this.pagination.total = response.data.pagination.total
        }
      } catch (error) {
        ElMessage.error('加载数据失败')
        console.error('加载数据失败:', error)
      } finally {
        this.loading = false
      }
    },

    // 搜索
    handleSearch() {
      this.pagination.page = 1
      this.loadMerchantData()
    },

    // 重置搜索
    handleReset() {
      this.searchParams = {
        phone: '',
        nickname: '',
        status: ''
      }
      this.pagination.page = 1
      this.loadMerchantData()
    },

    // 分页大小改变
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.page = 1
      this.loadMerchantData()
    },

    // 当前页改变
    handleCurrentChange(page) {
      this.pagination.page = page
      this.loadMerchantData()
    },

    // 打开RPA接口配置对话框
    handleRpaConfig(row) {
      this.rpaConfigForm = {
        id: row.id,
        wpah_api_gzh_auth: row.wpah_api_gzh_auth || '',
        wpah_api_gzh_fb: row.wpah_api_gzh_fb || '',
        wpah_api_gzh_check_cookies: row.wpah_api_gzh_check_cookies || ''
      }
      this.showRpaConfigDialog = true
    },

    // 提交RPA接口配置
    async handleRpaConfigSubmit() {
      try {
        this.rpaConfigSubmitting = true

        const requestData = {
          action: 'update_rpa_config',
          store_id: this.userInfo.id,
          id: this.rpaConfigForm.id,
          ...this.rpaConfigForm
        }

        const response = await axios.post(`${config.BASE_URL}/site/api/user_management.php`, requestData)

        if (response.data.success) {
          ElMessage.success('RPA接口配置更新成功')
          this.showRpaConfigDialog = false
          this.loadMerchantData()
        } else {
          ElMessage.error(response.data.error || '配置更新失败')
        }
      } catch (error) {
        ElMessage.error('配置更新失败')
        console.error('配置更新失败:', error)
      } finally {
        this.rpaConfigSubmitting = false
      }
    },

    // 显示添加对话框
    showAddDialog() {
      this.showDialog = true
      this.formData = {
        id: null,
        phone: '',
        nickname: '',
        password: '',
        gender: 0,
        status: 1,
        out_date: '',
        // 原有字段默认值
        dianshu: 0,
        deduct_points: 1,
        email: '',
        third_party_media_count: 1,
        b2b_count: 1,
        self_media_count: 1,
        ai_agent_website_count: 1,
        // 新增字段默认值
        sq_num: null,
        official_auth_count: null,
        account_pool: null,
        training_text_enabled: null,
        auth_account_enabled: null,
        api_config_enabled: null,
        storage_config_enabled: null,
        ai_agent_enabled: null,
        wpah_api_gzh_auth: '',
        wpah_api_gzh_fb: '',
        wpah_api_gzh_check_cookies: ''
      }
    },

    // 编辑商户
    handleEdit(row) {
      this.showDialog = true
      this.formData = {
        id: row.id,
        phone: row.phone,
        nickname: row.nickname,
        password: '',
        gender: Number(row.gender),
        status: Number(row.status),
        out_date: row.out_date,
        // 原有字段 - 确保数字类型
        dianshu: Number(row.dianshu) || 0,
        deduct_points: Number(row.deduct_points) || 1,
        email: row.email || '',
        third_party_media_count: Number(row.third_party_media_count) || 1,
        b2b_count: Number(row.b2b_count) || 1,
        self_media_count: Number(row.self_media_count) || 1,
        ai_agent_website_count: Number(row.ai_agent_website_count) || 1,
        // 新增字段
        sq_num: Number(row.sq_num) || null,
        official_auth_count: Number(row.official_auth_count) || null,
        account_pool: Number(row.account_pool) || 0,
        training_text_enabled: Number(row.training_text_enabled) || 0,
        auth_account_enabled: Number(row.auth_account_enabled) || 0,
        api_config_enabled: Number(row.api_config_enabled) || 0,
        storage_config_enabled: Number(row.storage_config_enabled) || 0,
        ai_agent_enabled: Number(row.ai_agent_enabled) || 0,
        wpah_api_gzh_auth: row.wpah_api_gzh_auth || '',
        wpah_api_gzh_fb: row.wpah_api_gzh_fb || '',
        wpah_api_gzh_check_cookies: row.wpah_api_gzh_check_cookies || ''
      }
    },

    // 提交表单
    async handleSubmit() {
      if (!this.$refs.formRef) return

      try {
        const valid = await this.$refs.formRef.validate()
        if (!valid) return

        this.submitting = true

        const requestData = {
          store_id: this.userInfo.id,
          phone: this.formData.phone,
          nickname: this.formData.nickname,
          gender: Number(this.formData.gender),
          status: Number(this.formData.status),
          out_date: this.formData.out_date,
          // 原有字段 - 确保数字类型
          dianshu: Number(this.formData.dianshu),
          deduct_points: Number(this.formData.deduct_points),
          email: this.formData.email,
          third_party_media_count: Number(this.formData.third_party_media_count),
          b2b_count: Number(this.formData.b2b_count),
          self_media_count: Number(this.formData.self_media_count),
          ai_agent_website_count: Number(this.formData.ai_agent_website_count),
          // 新增字段
          sq_num: this.formData.sq_num ? Number(this.formData.sq_num) : null,
          official_auth_count: this.formData.official_auth_count ? Number(this.formData.official_auth_count) : null,
          account_pool: Number(this.formData.account_pool),
          training_text_enabled: Number(this.formData.training_text_enabled),
          auth_account_enabled: Number(this.formData.auth_account_enabled),
          api_config_enabled: Number(this.formData.api_config_enabled),
          storage_config_enabled: Number(this.formData.storage_config_enabled),
          ai_agent_enabled: Number(this.formData.ai_agent_enabled),
          wpah_api_gzh_auth: this.formData.wpah_api_gzh_auth,
          wpah_api_gzh_fb: this.formData.wpah_api_gzh_fb,
          wpah_api_gzh_check_cookies: this.formData.wpah_api_gzh_check_cookies
        }

        if (this.isAdd) {
          requestData.action = 'add'
          requestData.password = this.formData.password
        } else {
          requestData.action = 'update'
          requestData.id = this.formData.id
        }

        const response = await axios.post(`${config.BASE_URL}/site/api/user_management.php`, requestData)

        if (response.data.success) {
          ElMessage.success(this.isAdd ? '添加成功' : '更新成功')
          this.showDialog = false
          this.loadMerchantData()
        } else {
          ElMessage.error(response.data.error || '操作失败')
        }
      } catch (error) {
        ElMessage.error('操作失败')
        console.error('操作失败:', error)
      } finally {
        this.submitting = false
      }
    },

    // 打开AI接口配置对话框
    handleApiConfig(row) {
      this.apiConfigForm = {
        id: row.id,
        // Coze配置
        coze_access_token: row.coze_access_token || '',
        coze_name: row.coze_name || '',
        coze_botid: row.coze_botid || '',
        coze_chat_mode: row.coze_chat_mode || 'stream',
        coze_timeout: Number(row.coze_timeout) || 30,
        coze_enabled: Number(row.coze_enabled) || 1,
        // OpenAI配置
        openai_url: row.openai_url || '',
        openai_key: row.openai_key || '',
        openai_model: row.openai_model || '',
        openai_max_tokens: Number(row.openai_max_tokens) || 2000,
        openai_temperature: Number(row.openai_temperature) || 0.7,
        openai_enabled: Number(row.openai_enabled) || 1
      }
      this.showApiConfigDialog = true
      this.apiConfigActiveTab = 'coze'
    },

    // 提交AI接口配置
    async handleApiConfigSubmit() {
      try {
        this.apiConfigSubmitting = true

        const requestData = {
          action: 'update_api_config',
          store_id: this.userInfo.id,
          id: this.apiConfigForm.id,
          ...this.apiConfigForm
        }

        const response = await axios.post(`${config.BASE_URL}/site/api/user_management.php`, requestData)

        if (response.data.success) {
          ElMessage.success('AI接口配置更新成功')
          this.showApiConfigDialog = false
          this.loadMerchantData()
        } else {
          ElMessage.error(response.data.error || '配置更新失败')
        }
      } catch (error) {
        ElMessage.error('配置更新失败')
        console.error('配置更新失败:', error)
      } finally {
        this.apiConfigSubmitting = false
      }
    },

    // 打开存储配置对话框
    handleStorageConfig(row) {
      this.storageConfigForm = {
        id: row.id,
        // 阿里云配置
        aliyun_keyid: row.aliyun_keyid || '',
        aliyun_secret: row.aliyun_secret || '',
        endpoint: row.endpoint || '',
        aliyun_bucket: row.aliyun_bucket || '',
        aliyun_domain: row.aliyun_domain || '',
        aliyun_enabled: Number(row.aliyun_enabled) || 1,
        // 腾讯云配置
        tencent_secret_id: row.tencent_secret_id || '',
        tencent_secret_key: row.tencent_secret_key || '',
        tencent_bucket: row.tencent_bucket || '',
        tencent_region: row.tencent_region || '',
        tencent_domain: row.tencent_domain || '',
        tencent_enabled: Number(row.tencent_enabled) || 1,
        // 七牛云配置
        qiniu_access_key: row.qiniu_access_key || '',
        qiniu_secret_key: row.qiniu_secret_key || '',
        qiniu_bucket: row.qiniu_bucket || '',
        qiniu_region: row.qiniu_region || '',
        qiniu_domain: row.qiniu_domain || '',
        qiniu_enabled: Number(row.qiniu_enabled) || 1,
        // 云服务商选择
        cloud_provider: row.cloud_provider || 'local'  // 默认本地存储
      }
      this.showStorageConfigDialog = true

      // 根据选择的云服务商设置激活的tab
      if (this.storageConfigForm.cloud_provider !== 'local') {
        this.storageConfigActiveTab = this.storageConfigForm.cloud_provider
      } else {
        this.storageConfigActiveTab = 'aliyun' // 默认显示阿里云tab，但会被隐藏
      }
    },

    // 提交存储配置
    async handleStorageConfigSubmit() {
      try {
        this.storageConfigSubmitting = true

        const requestData = {
          action: 'update_storage_config',
          store_id: this.userInfo.id,
          id: this.storageConfigForm.id,
          ...this.storageConfigForm
        }

        const response = await axios.post(`${config.BASE_URL}/site/api/user_management.php`, requestData)

        if (response.data.success) {
          ElMessage.success('存储配置更新成功')
          this.showStorageConfigDialog = false
          this.loadMerchantData()
        } else {
          ElMessage.error(response.data.error || '配置更新失败')
        }
      } catch (error) {
        ElMessage.error('配置更新失败')
        console.error('配置更新失败:', error)
      } finally {
        this.storageConfigSubmitting = false
      }
    },

    // 改变状态
    async handleChangeStatus(row) {
      try {
        await ElMessageBox.confirm(
          `确定要${row.status ? '禁用' : '启用'}该用户吗？`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )

        const response = await axios.post(`${config.BASE_URL}/site/api/user_management.php`, {
          action: 'change_status',
          store_id: this.userInfo.id,
          id: row.id,
          status: row.status ? 0 : 1
        })

        if (response.data.success) {
          ElMessage.success(response.data.success)
          this.loadMerchantData()
        } else {
          ElMessage.error(response.data.error || '操作失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('操作失败')
        }
      }
    },

    // 删除商户
    async handleDelete(row) {
      try {
        await ElMessageBox.confirm(
          '确定要删除该用户吗？',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )

        const response = await axios.post(`${config.BASE_URL}/site/api/user_management.php`, {
          action: 'delete',
          store_id: this.userInfo.id,
          id: row.id
        })

        if (response.data.success) {
          ElMessage.success('删除成功')
          this.loadMerchantData()
        } else {
          ElMessage.error(response.data.error || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('删除失败')
        }
      }
    },

    // 打开重置密码对话框
    handleResetPassword(row) {
      this.resetPasswordForm = {
        id: row.id,
        password: '',
        confirmPassword: ''
      }
      this.showResetPasswordDialog = true
      this.$nextTick(() => {
        if (this.$refs.resetPasswordFormRef) {
          this.$refs.resetPasswordFormRef.clearValidate()
        }
      })
    },

    // 提交重置密码
    async handleResetPasswordSubmit() {
      if (!this.$refs.resetPasswordFormRef) return

      try {
        const valid = await this.$refs.resetPasswordFormRef.validate()
        if (!valid) return

        this.resettingPassword = true

        const response = await axios.post(`${config.BASE_URL}/site/api/user_management.php`, {
          action: 'reset_password',
          store_id: this.userInfo.id,
          id: this.resetPasswordForm.id,
          password: this.resetPasswordForm.password
        })

        if (response.data.success) {
          ElMessage.success('密码重置成功')
          this.showResetPasswordDialog = false
          this.loadMerchantData()
        } else {
          ElMessage.error(response.data.error || '密码重置失败')
        }
      } catch (error) {
        ElMessage.error('密码重置失败')
        console.error('密码重置失败:', error)
      } finally {
        this.resettingPassword = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.merchant-management-container {
  min-height: calc(100vh - 160px);
  background: transparent;
}

.main-content {
  background: hsla(0, 0%, 100%, .1);
  border-radius: 8px;
  padding: 24px;
  backdrop-filter: blur(10px);
}

.button-group {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.local-storage-tip {
  margin-bottom: 20px;
}

.local-storage-tip .el-alert {
  background: rgba(255, 112, 72, 0.1);
  border: 1px solid rgba(255, 112, 72, 0.3);
}

.local-storage-tip .el-alert__title {
  color: #ff7048;
}

.local-storage-tip p {
  margin: 5px 0 0 0;
  color: #e0e6ff;
  font-size: 14px;
}

.main-button {
  padding: 12px 24px;
  background: #ff7048;
  border: 1px solid #ff7048;
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #e55a3a;
    border-color: #e55a3a;
    transform: translateY(-2px);
  }

  &.active {
    background: #ff7048;
    border-color: #ff7048;
  }
}

.sub-button-group {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  align-items: center;
  flex-wrap: wrap;
}

.sub-button {
  padding: 8px 16px;
  background: #ff7048;
  border: 1px solid #ff7048;
  border-radius: 6px;
  color: #ffffff;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #e55a3a;
    border-color: #e55a3a;
  }

  &.orange-button {
    background: #ff7048;
    border-color: #ff7048;

    &:hover {
      background: #e55a3a;
      border-color: #e55a3a;
    }
  }
}

.content-area {
  min-height: 400px;
}

// 商户管理样式
.action-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 16px;

  .search-bar {
    display: flex;
    gap: 12px;
    align-items: center;
    flex-wrap: wrap;

    .search-input,
    .status-select {
      width: 160px;
    }
  }
}

.data-table {
  background: transparent;

  :deep(.el-table) {
    background: transparent;

    th {
      background: transparent !important;
      color: #e0e6ff !important;
      border-bottom: 1px solid rgba(255, 112, 72, 0.3) !important;
    }

    tr {
      background: rgba(255, 255, 255, 0.05);

      &:hover {
        background: rgba(255, 255, 255, 0.1) !important;
      }
    }

    td {
      color: #e0e6ff !important;
      border-bottom: 1px solid rgba(255, 112, 72, 0.1) !important;
    }
  }

  .action-btn {
    margin: 2px;
    font-size: 12px;
    padding: 4px 8px;
  }
}

.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  padding: 20px 0;
}

.quota-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.quota-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}

.quota-label {
  color: #a0a0a0;
  min-width: 50px;
}

.function-status {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.status-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}

.status-label {
  color: #a0a0a0;
  min-width: 35px;
}

.unlimited-text {
  color: #ff7048;
  font-weight: 600;
}

.empty-text {
  color: #a0a0a0;
  font-style: italic;
}

.field-tip {
  font-size: 12px;
  color: #a0a0a0;
  margin-top: 4px;
}

.slider-value {
  margin-left: 10px;
  color: #ff7048;
  font-weight: 600;
}

// 响应式设计
@media (max-width: 768px) {
  .merchant-management-container {
    padding: 16px;
  }

  .button-group {
    gap: 12px;

    .main-button {
      padding: 10px 20px;
      font-size: 13px;
    }
  }

  .sub-button-group {
    gap: 8px;

    .sub-button {
      padding: 6px 12px;
      font-size: 12px;
    }
  }

  .action-bar {
    flex-direction: column;
    align-items: stretch;

    .search-bar {
      justify-content: center;

      .search-input,
      .status-select {
        width: 100%;
        max-width: 200px;
      }
    }
  }

  .data-table .action-btn {
    font-size: 10px;
    padding: 2px 4px;
    margin: 1px;
  }
}

@media (max-width: 480px) {
  .main-content {
    padding: 16px;
  }

  .button-group {
    justify-content: center;
  }

  .sub-button-group {
    justify-content: center;
  }
}
</style>

<style>
/* 商户管理对话框全局样式 */
.merchant-dialog .el-dialog {
  background: rgba(13, 5, 26, 0.95) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 112, 72, 0.3);
  border-radius: 16px;
}

.merchant-dialog .el-dialog__header {
  margin: 0 !important;
  padding: 20px !important;
  border-bottom: 1px solid rgba(255, 112, 72, 0.2);
}

.merchant-dialog .el-dialog__title {
  color: #ffffff !important;
  font-weight: 600;
  font-size: 18px;
}

.merchant-dialog .el-dialog__body {
  padding: 20px !important;
  background: transparent !important;
  max-height: 70vh;
  overflow-y: auto;
}

.merchant-dialog .el-dialog__footer {
  border-top: 1px solid rgba(255, 112, 72, 0.2) !important;
  padding: 16px 20px !important;
  margin: 0 !important;
}

/* 表单样式 */
.merchant-dialog .el-form-item__label {
  color: #e0e6ff !important;
  font-weight: 500;
}

.merchant-dialog .el-input__inner,
.merchant-dialog .el-textarea__inner {
  color: #ffffff !important;
}

.merchant-dialog .el-input__inner::placeholder,
.merchant-dialog .el-textarea__inner::placeholder {
  color: rgba(255, 255, 255, 0.5) !important;
}

.merchant-dialog .el-input__wrapper:hover {
  border-color: #ff7048 !important;
}

.merchant-dialog .el-input__wrapper.is-focus {
  border-color: #ff7048 !important;
  box-shadow: 0 0 0 1px #ff7048 !important;
}

/* 选择器样式 */
.merchant-dialog .el-select .el-input__inner {
  color: #ffffff !important;
}

.merchant-dialog .el-select .el-select__caret {
  color: #ff7048 !important;
}

/* 单选按钮样式 */
.merchant-dialog .el-radio__label {
  color: #e0e6ff !important;
}

.merchant-dialog .el-radio__input.is-checked .el-radio__inner {
  background-color: #ff7048 !important;
  border-color: #ff7048 !important;
}

/* 开关样式 */
.merchant-dialog .el-switch__core {
  background: rgba(255, 255, 255, 0.2) !important;
  border: 1px solid rgba(255, 112, 72, 0.3) !important;
}

.merchant-dialog .el-switch.is-checked .el-switch__core {
  background: #ff7048 !important;
  border-color: #ff7048 !important;
}

/* 日期选择器样式 */
.merchant-dialog .el-picker__panel {
  background: rgba(13, 5, 26, 0.95) !important;
  border: 1px solid rgba(255, 112, 72, 0.3) !important;
}

.merchant-dialog .el-date-picker .el-picker-panel__icon-btn,
.merchant-dialog .el-date-picker .el-date-table th {
  color: #e0e6ff !important;
}

.merchant-dialog .el-date-picker .el-date-table td.available:hover {
  color: #ff7048 !important;
}

.merchant-dialog .el-date-picker .el-date-table td.current:not(.disabled) span {
  background: #ff7048 !important;
}

/* 按钮样式 */
.merchant-dialog .el-button {
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.merchant-dialog .el-button--primary {
  background: #ff7048 !important;
  border-color: #ff7048 !important;
}

.merchant-dialog .el-button--primary:hover {
  background: #e55a3a !important;
  border-color: #e55a3a !important;
  transform: translateY(-1px);
}

/* 分页样式 */
.el-pagination {
  --el-pagination-bg-color: transparent !important;
  --el-pagination-text-color: #e0e6ff !important;
  --el-pagination-button-color: #e0e6ff !important;
  --el-pagination-button-disabled-bg-color: transparent !important;
  --el-pagination-hover-color: #ff7048 !important;
}

.el-pagination .btn-prev,
.el-pagination .btn-next,
.el-pagination .number {
  background: rgba(255, 255, 255, 0.1) !important;
  border: 1px solid rgba(255, 112, 72, 0.3) !important;
  color: #e0e6ff !important;
}

.el-pagination .number.active {
  background: #ff7048 !important;
  border-color: #ff7048 !important;
  color: #ffffff !important;
}

.el-pagination .number:hover {
  color: #ff7048 !important;
}

/* Tab样式 */
.merchant-dialog .el-tabs__item {
  color: #e0e6ff !important;
}

.merchant-dialog .el-tabs__item.is-active {
  color: #ff7048 !important;
}

.merchant-dialog .el-tabs__active-bar {
  background-color: #ff7048 !important;
}

.merchant-dialog .el-tabs__nav-wrap::after {
  background-color: rgba(255, 112, 72, 0.3) !important;
}

/* 滑块样式 */
.merchant-dialog .el-slider__bar {
  background: #ff7048 !important;
}

.merchant-dialog .el-slider__button {
  border-color: #ff7048 !important;
}

.merchant-dialog .el-divider__text {
  background: rgba(13, 5, 26, 0.95) !important;
  color: #ff7048 !important;
  font-size: 14px;
  font-weight: 600;
}

.merchant-dialog .el-input-number {
  width: 100%;
}

.merchant-dialog .el-input-number .el-input__inner {
  text-align: left;
}
</style>